// Picking which of two selected customers survives a merge (the owner can
// change it in the merge dialog). Used by MergeCustomersDialog.

export interface MergeCandidate {
  /** The row's key in the customer list. */
  key: string;
  /** CRM record id, or null for a messaging-only profile. */
  customerId: string | null;
  contactId: string | null;
  name: string;
  identity: string | null;
  email: string | null;
  phone: string | null;
  totalBookings: number;
  createdAt: string;
}

/** Keep the profile with the most history by default. */
export function defaultKeepKey(candidates: [MergeCandidate, MergeCandidate]): string {
  const [a, b] = candidates;
  if (a.totalBookings !== b.totalBookings) return a.totalBookings > b.totalBookings ? a.key : b.key;
  if (!!a.customerId !== !!b.customerId) return a.customerId ? a.key : b.key;
  return new Date(a.createdAt).getTime() <= new Date(b.createdAt).getTime() ? a.key : b.key;
}
